import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Backward = (props: IconProps) => (
  <Icon
    width="60"
    height="41"
    viewBox="0 0 60 41"
    fill="none"
    _hover={{ '&>rect': { fill: '#C29F6B', stroke: '#C29F6B' }, '&>path': { fill: 'white' } }}
    {...props}
  >
    <rect
      x="-0.5"
      y="0.5"
      width="59"
      height="39"
      transform="matrix(-1 0 0 1 59 0.613281)"
      fill="white"
      stroke="#899396"
    />
    <path
      d="M46.0466 21.1133C46.3228 21.1133 46.5466 20.8894 46.5466 20.6133C46.5466 20.3371 46.3228 20.1133 46.0466 20.1133L46.0466 21.1133ZM14.9954 20.2597C14.8001 20.455 14.8001 20.7716 14.9954 20.9668L18.1774 24.1488C18.3726 24.3441 18.6892 24.3441 18.8845 24.1488C19.0798 23.9536 19.0798 23.637 18.8845 23.4417L16.0561 20.6133L18.8845 17.7849C19.0798 17.5896 19.0798 17.273 18.8845 17.0777C18.6892 16.8825 18.3726 16.8825 18.1774 17.0777L14.9954 20.2597ZM46.0466 20.1133L15.349 20.1133L15.349 21.1133L46.0466 21.1133L46.0466 20.1133Z"
      fill="black"
    />
  </Icon>
);
